module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('name'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Name",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('email'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email",
      "data-vv-rules": "required|email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('password'),
      'is-disabled': _vm.inProgress,
      'password': true
    },
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "Password",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Department")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.departament),
      expression: "user.departament"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "departament",
      "id": "departament"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "departament", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.context.$store.state.config.departaments), function(departament) {
    return _c('option', {
      domProps: {
        "value": departament.id
      }
    }, [_vm._v(_vm._s(departament.name))])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Level")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.level),
      expression: "user.level"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "level",
      "id": "level"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.context.$store.state.config.users.level), function(level) {
    return (level.id >= 1 && level.id <= 3) ? _c('option', {
      domProps: {
        "value": level.id
      }
    }, [_vm._v(_vm._s(level.name))]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.occurrences),
      expression: "user.occurrences"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.occurrences) ? _vm._i(_vm.user.occurrences, null) > -1 : (_vm.user.occurrences)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.occurrences,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "occurrences", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "occurrences", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "occurrences", $$c)
        }
      }
    }
  }), _vm._v("\n          Tickets\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.reconfirmations),
      expression: "user.reconfirmations"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.reconfirmations) ? _vm._i(_vm.user.reconfirmations, null) > -1 : (_vm.user.reconfirmations)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.reconfirmations,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "reconfirmations", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "reconfirmations", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "reconfirmations", $$c)
        }
      }
    }
  }), _vm._v("\n          Reconfirmation\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.extend_card),
      expression: "user.extend_card"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.extend_card) ? _vm._i(_vm.user.extend_card, null) > -1 : (_vm.user.extend_card)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.extend_card,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "extend_card", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "extend_card", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "extend_card", $$c)
        }
      }
    }
  }), _vm._v("\n          Extend Card\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.move_service_po),
      expression: "user.move_service_po"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.move_service_po) ? _vm._i(_vm.user.move_service_po, null) > -1 : (_vm.user.move_service_po)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.move_service_po,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "move_service_po", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "move_service_po", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "move_service_po", $$c)
        }
      }
    }
  }), _vm._v("\n          Move Service - Payment Order\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.delete_service_po),
      expression: "user.delete_service_po"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.delete_service_po) ? _vm._i(_vm.user.delete_service_po, null) > -1 : (_vm.user.delete_service_po)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.delete_service_po,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "delete_service_po", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "delete_service_po", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "delete_service_po", $$c)
        }
      }
    }
  }), _vm._v("\n          Delete Service - Payment Order\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.revert_payment),
      expression: "user.revert_payment"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.revert_payment) ? _vm._i(_vm.user.revert_payment, null) > -1 : (_vm.user.revert_payment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.revert_payment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "revert_payment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "revert_payment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "revert_payment", $$c)
        }
      }
    }
  }), _vm._v("\n            Revert Payment - Payment Order\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.move_service_invoice),
      expression: "user.move_service_invoice"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.move_service_invoice) ? _vm._i(_vm.user.move_service_invoice, null) > -1 : (_vm.user.move_service_invoice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.move_service_invoice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "move_service_invoice", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "move_service_invoice", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "move_service_invoice", $$c)
        }
      }
    }
  }), _vm._v("\n          Move Service - Invoice\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.delete_service_invoice),
      expression: "user.delete_service_invoice"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.delete_service_invoice) ? _vm._i(_vm.user.delete_service_invoice, null) > -1 : (_vm.user.delete_service_invoice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.delete_service_invoice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "delete_service_invoice", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "delete_service_invoice", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "delete_service_invoice", $$c)
        }
      }
    }
  }), _vm._v("\n          Delete Service - Invoice\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.validate_charges),
      expression: "user.validate_charges"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.validate_charges) ? _vm._i(_vm.user.validate_charges, null) > -1 : (_vm.user.validate_charges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.validate_charges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "validate_charges", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "validate_charges", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "validate_charges", $$c)
        }
      }
    }
  }), _vm._v("\n          Validate Charges\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.generate_boleto),
      expression: "user.generate_boleto"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.generate_boleto) ? _vm._i(_vm.user.generate_boleto, null) > -1 : (_vm.user.generate_boleto)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.generate_boleto,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "generate_boleto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "generate_boleto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "generate_boleto", $$c)
        }
      }
    }
  }), _vm._v("\n          Generate Boleto\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.occurrence_config),
      expression: "user.occurrence_config"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.occurrence_config) ? _vm._i(_vm.user.occurrence_config, null) > -1 : (_vm.user.occurrence_config)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.occurrence_config,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "occurrence_config", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "occurrence_config", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "occurrence_config", $$c)
        }
      }
    }
  }), _vm._v("\n          Ticket Config\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.dispute_payment),
      expression: "user.dispute_payment"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.dispute_payment) ? _vm._i(_vm.user.dispute_payment, null) > -1 : (_vm.user.dispute_payment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.dispute_payment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "dispute_payment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "dispute_payment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "dispute_payment", $$c)
        }
      }
    }
  }), _vm._v("\n          Dispute Payment\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.refunds_po),
      expression: "user.refunds_po"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.refunds_po) ? _vm._i(_vm.user.refunds_po, null) > -1 : (_vm.user.refunds_po)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.refunds_po,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "refunds_po", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "refunds_po", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "refunds_po", $$c)
        }
      }
    }
  }), _vm._v("\n          Refunds PO\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Telephone Extension")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.telephone_extension),
      expression: "user.telephone_extension"
    }],
    class: {
      'input': true,
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "telephone_extension",
      "id": "telephone_extension",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.telephone_extension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "telephone_extension", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any(),
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cc015f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/users/User.vue
// module id = 1155
// module chunks = 39